import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageSwingAverageStance = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_94",
		"data-name": "Group 94",
		transform: "translate(-146.922 -642.511)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_27",
			"data-name": "Rectangle 27",
			width: 24,
			height: 24,
			transform: "translate(147.422 643.011)",
			fill: "none",
			stroke: "#040505",
			strokeMiterlimit: 10,
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_93",
			"data-name": "Group 93",
			transform: "translate(148.195 646.374)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_224",
					"data-name": "Path 224",
					d: "M202.4,694.076h-2.249a.75.75,0,0,0,0,1.5H202.4a.75.75,0,0,0,0-1.5Z",
					transform: "translate(-180.693 -678.302)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_225",
					"data-name": "Path 225",
					d: "M176.359,694.076h-5.486a.75.75,0,0,0,0,1.5h5.486a.75.75,0,0,0,0-1.5Z",
					transform: "translate(-162.389 -678.302)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_226",
					"data-name": "Path 226",
					d: "M152.483,694.076h-2.249a.75.75,0,0,0,0,1.5h2.249a.75.75,0,0,0,0-1.5Z",
					transform: "translate(-149.485 -678.302)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_227",
					"data-name": "Path 227",
					d: "M167.272,667.34c.146-.008,3.593-.226,5.375-1.687a2.656,2.656,0,0,0,1.173-2.7,1.617,1.617,0,0,0-1.4-1.151c-.277-.031-.594-.063-.933-.1a16.33,16.33,0,0,1-3.754-.63c-.725-.359-2.476-1.458-4.806-3.013a.889.889,0,0,0-.5-.147c-.017-.175-.03-.361-.031-.567,0-1.312.019-4.58.02-4.613a.75.75,0,0,0-.744-.755h-.006a.75.75,0,0,0-.75.744c0,.033-.024,3.309-.02,4.629a6.714,6.714,0,0,0,.352,2.2c0,.024-.009.046-.013.071a2.389,2.389,0,0,1-1.435.188,3.071,3.071,0,0,1-1.1-.608c-.025-.021-.055-.034-.082-.054.048-.269.1-.611.161-1.057a21.712,21.712,0,0,0-.294-4.767.75.75,0,1,0-1.48.242,19.888,19.888,0,0,1,.29,4.311c-.084.582-.14.917-.175,1.107a1.513,1.513,0,0,0-.715.645,7.387,7.387,0,0,0-.557,1.294,13.575,13.575,0,0,0-.588,2.525,4.474,4.474,0,0,0-.714,1.522.748.748,0,0,0,.1.695,4.662,4.662,0,0,0,3.419,1.58c1.011.089,3.115.112,5.059.112C165.208,667.37,167.106,667.343,167.272,667.34Zm-9.9-8.487c-.017.011-.033.024-.049.036C157.341,658.877,157.355,658.864,157.373,658.853Zm-.114.089-.013.014h0Zm.936,6.824a3.879,3.879,0,0,1-2.069-.721c.094-.24.183-.448.237-.552l.086-.07a.755.755,0,0,0,.274-.532,11.228,11.228,0,0,1,.548-2.482,5.216,5.216,0,0,1,.457-1.041.016.016,0,0,1,.016,0,4.438,4.438,0,0,0,1.665.9,4.094,4.094,0,0,0,2.9-.5.75.75,0,0,0,.358-.557c.018-.154.043-.317.073-.469,1.427.944,3.409,2.225,4.327,2.681a14.843,14.843,0,0,0,4.272.778c.331.033.641.064.911.094.112.013.125.058.133.085.052.178-.087.622-.685,1.113-1.166.955-3.653,1.3-4.48,1.348C167.148,665.844,160.216,665.942,158.2,665.765Z",
					transform: "translate(-152.622 -651.985)",
					fill: "current"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgAverageSwingAverageStance);
export { ForwardRef as ReactComponent };
